import { ApiRoutes } from "consts/enpoints/api";
import { HttpVerb } from "consts/api";
import { fetchApi } from "infrastructure/api";
import type { WaMessageSetup, WaTemplateSetup } from "./types";

export const getWaMessages = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetWaMessages}${queryString}`);

export const getWaMessagesSetups = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetWaMessagesSetups}${queryString}`);

export const createWaMessagesSetup = (body: Partial<WaMessageSetup>) =>
    fetchApi(ApiRoutes.PostWaMessagesSetups, {
        method: HttpVerb.Post,
        body
    });

export const updateWaMessagesSetup = ({ coreId, ...body }: Partial<WaMessageSetup>) =>
    fetchApi(ApiRoutes.PutWaMessagesSetups(coreId), {
        method: HttpVerb.Put,
        body
    });

export const getPhoneVerifications = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetPhoneVerifications}${queryString}`);

export const getFailedPhoneVerifications = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetFailedPhoneVerifications}${queryString}`);

export const getWaTemplatesSetups = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetWaTemplatesSetups}${queryString}`);

export const createWaTemplatesSetup = (body: Partial<WaTemplateSetup>) =>
    fetchApi(ApiRoutes.PostWaTemplatesSetups, {
        method: HttpVerb.Post,
        body
    });

export const updateWaTemplatesSetup = ({ coreId, ...body }: Partial<WaTemplateSetup>) =>
    fetchApi(ApiRoutes.PutWaTemplatesSetups(coreId), {
        method: HttpVerb.Put,
        body
    });
